const PlayTriangle = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="39" viewBox="0 0 33 39" fill="none">
<path d="M0.0849609 38.7498V0.558594L32.7127 19.6523L0.0849609 38.7498Z" fill="white"/>
</svg>
    )
}
export default PlayTriangle;